import { render, staticRenderFns } from "./SignUpPageBankAccount.vue?vue&type=template&id=49f5c092&"
import script from "./SignUpPageBankAccount.vue?vue&type=script&lang=js&"
export * from "./SignUpPageBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports